import React from 'react';
import bowser from 'yola-bowser';
import { Popover, PopoverContent, PopoverTrigger } from '../../popover';

const withPopover = (Component) => {
  const Wrapped = ({ popoverProps, disabled = false, ...restProps }) => {
    const isTouchDevice = bowser.mobile || bowser.tablet;
    const componentProps = restProps;

    if (isTouchDevice || disabled) {
      return <Component disabled={disabled} {...componentProps} />;
    }

    return (
      <Popover
        title={popoverProps.title}
        hotkey={popoverProps.hotkey}
        description={popoverProps.content}
        placement="bottom-right"
      >
        <PopoverTrigger>
          <Component {...componentProps} />
        </PopoverTrigger>
        <PopoverContent />
      </Popover>
    );
  };

  return Wrapped;
};

export default withPopover;
